import { Serializable } from "../utilities/Serializable";
import { PriceList } from "./Pricelist";
import { Product } from "./Product";

export class PricelistProduct extends Serializable { 
    uuid: string;
    price: number;
    priceList: PriceList;
    product: Product;
}


// WEBPACK FOOTER //
// ./src/app/models/PriceListProduct.ts